/*
 * The apps tab in the catalog.  This replaces the single app catalog (AppSummary) for use in the
 * reseller portal.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import TabPageTitle from '../ui/TabPageTitle';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Typography } from '@mui/material';

import Add from '@mui/icons-material/Add';

import AppList from './AppList';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const CatalogAppsQuery = graphql`
query CatalogAppsQuery($accountId: UUID!, $searchParm: String!, $first: Int) {
  appsearchconfiguredbyappname(accountid: $accountId, search: $searchParm, first: $first) {
    totalCount
    ...AppList_al
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  appDiv: {
    marginTop: 8
  }
});

class CatalogApps extends Component {
  state = {
    searchP: '',
  };

  componentDidMount() {
    // Is there something in local storage?
    let sTerm = localStorage.getItem('catalogAppsSterms');

    if (sTerm == null)
      sTerm = '';

    this.setState({searchP: sTerm});
  }

  goTo(route) {
    localStorage.setItem('catalogAppsSterms', this.state.searchP);
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let numberToShow = 50;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedReseller())
    {
      let accountId = abEnvironment.getUserAttribute('a_id');

      return (
        <div className={classes.root}>

          <Grid container spacing={1} direction="row" justifyContent="flex-start">
            {this.props.showTitle === true &&
            <Grid item xs={12}>
              <TabPageTitle title="View apps you've set up" subtitle="When you buy a subscription to an app, settings are saved here as a template for future purchases."/>
            </Grid>}
            <Grid item xs={12}>
              <Grid container spacing={2} direction="row" justifyContent="flex-start">
                <Grid item>
                  {this.props.showTitle === true &&
                  <Button
                    color="primary"
                    variant="contained"
                    style={AppBindStyles.addButtonOnSearch}
                    onClick={() => {this.goTo('appcreate');}}>
                    <Add/> Add app
                  </Button>}
                  {this.props.showTitle === false &&
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {this.goTo('appcreate');}}>
                    <Add/> Add app
                  </Button>}
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <SearchField
                id="searchP"
                label="Search by name"
                value={this.state.searchP}
                onChange={this.handleChange('searchP')}
              />
            </Grid>
          </Grid>
 
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={CatalogAppsQuery}
            variables={{accountId: accountId, searchParm: this.state.searchP, first: numberToShow}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
            } else if (props) {
                return (
                  <div className={classes.appDiv}>
                    {
                      this.state.searchP.length === 0 &&
                      props.appsearchconfiguredbyappname.totalCount === 0 && (
                        <Typography>You haven't purchased or set up any apps yet</Typography>
                      )
                    }
                    {
                      this.state.searchP.length > 0 &&
                      props.appsearchconfiguredbyappname.totalCount === 0 && (
                        <Typography>No matching apps</Typography>
                      )
                    }
                    {
                      this.state.searchP.length === 0 &&
                      props.appsearchconfiguredbyappname.totalCount === 1 && (
                        <Typography>1 app</Typography>
                      )
                    }
                    {
                      this.state.searchP.length > 0 &&
                      props.appsearchconfiguredbyappname.totalCount === 1 && (
                        <Typography>1 matching app</Typography>
                      )
                    }
                    {
                      this.state.searchP.length === 0 &&
                      props.appsearchconfiguredbyappname.totalCount > 1 &&
                      props.appsearchconfiguredbyappname.totalCount > numberToShow && (
                          <Typography>Showing {numberToShow} of {props.appsearchconfiguredbyappname.totalCount} apps</Typography>
                      )
                    }
                    {
                      this.state.searchP.length === 0 &&
                      props.appsearchconfiguredbyappname.totalCount > 1 &&
                      props.appsearchconfiguredbyappname.totalCount <= numberToShow && (
                          <Typography>{props.appsearchconfiguredbyappname.totalCount} apps</Typography>
                      )
                    }
                    {
                      this.state.searchP.length > 0 &&
                      props.appsearchconfiguredbyappname.totalCount > 1 &&
                      props.appsearchconfiguredbyappname.totalCount > numberToShow && (
                        <Typography>Showing {numberToShow} of {props.appsearchconfiguredbyappname.totalCount} matching apps</Typography>
                      )
                    }
                    {
                      this.state.searchP.length > 0 &&
                      props.appsearchconfiguredbyappname.totalCount > 1 &&
                      props.appsearchconfiguredbyappname.totalCount <= numberToShow && (
                        <Typography>{props.appsearchconfiguredbyappname.totalCount} matching apps</Typography>
                      )
                    }
                    <AppList al={props.appsearchconfiguredbyappname} sterm={this.state.searchP} auth={this.props.auth} history={this.props.history}/>
                  </div>
                )
              }
              return (
                <div className={classes.appDiv}>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </div>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

}

export default withStyles(styleSheet)(CatalogApps);
